import type { Dispatch } from '@reduxjs/toolkit';
import * as actions from '../actions/event';
import { done } from './promises';

export const events = {
  RouteChange: 'routechange',
  AdChange: 'adchange',
  RetailerChange: 'retailerchange',
};

type CallBack = (data?: any) => void;

const _callbacks: {
  routechange?: CallBack[];
  adchange?: CallBack[];
  retailerchange?: CallBack[];
} = {};
/*
const _eventNames = Object.keys(events)
    .map((key) => events[key as Keys])
    .reduce((next, current) => {
        next[current] = true;
        return next;
    }, {});
*/
const _eventNames = {
  routechange: true,
  adchange: true,
  retailerchange: true,
};

type EventNames = keyof typeof _eventNames;

const _eventCache: {
  routechange?: any;
  adchange?: any;
  retailerchange?: any;
} = {};

export const subscribe = (
  eventName: EventNames,
  callback: (data?: any) => void,
  triggerEventCache = false,
) => {
  if (typeof callback !== 'function' || !_eventNames[eventName]) {
    return false;
  }

  if (!_callbacks[eventName]) {
    _callbacks[eventName] = [];
  }

  _callbacks[eventName]?.push(callback);

  if (triggerEventCache && _eventCache[eventName]) {
    callback.call(null, _eventCache[eventName]);
  }

  return true;
};

export const unsubscribe = (eventName: EventNames, callback: (data?: any) => void) => {
  if (typeof callback !== 'function' || !_callbacks[eventName]) {
    return false;
  }

  const callbacks = _callbacks[eventName] || [];
  let result = false;
  for (let i = 0; i < callbacks.length; i++) {
    if (callbacks[i] === callback) {
      callbacks.splice(i, 1);
      result = true;
    }
  }

  if (result) {
    _callbacks[eventName] = callbacks;
  }

  return result;
};

export const publish = (eventName: EventNames, data: any, noCache = false) => {
  if (!noCache) {
    _eventCache[eventName] = data;
  }

  if (!_eventNames[eventName]) {
    return false;
  }

  const callbacks = _callbacks[eventName] || [];
  done(() => callbacks.forEach((callback) => callback.call(null, data)));

  return true;
};

export const attach = (root: { [key: string]: any }, dispatch: Dispatch) => {
  const pipe = (message: string) => actions.pipe(message)(dispatch);

  root.wayke = root.wayke || {};
  root.wayke.pubsub = { events, subscribe, unsubscribe, pipe };

  if (root.pubsubs)
    Object.keys(root.pubsubs).forEach((key) => subscribe(key as EventNames, root.pubsubs[key]));
};
